import { useParams } from 'react-router-dom'
import ModuleRecordForm from './ModuleRecordForm'
import { v4 as uuidv4 } from 'uuid'

const Create = () => {
    const params = useParams()

    return (
        <ModuleRecordForm
            inPopup={false}
            module={params.module.toString()}
            tempToken={uuidv4()}
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Record created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create record',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating record...',
                },
            }}
        />
    )
}

export default Create
